import { z } from 'zod';
/**
 * Liveness round-trip used by the Phase 1 wiring page. Safe to remove once real
 * features exercise the socket.
 */
export const pingPayloadSchema = z.object({
    /** Client clock reading when the ping was emitted, in epoch milliseconds. */
    sentAt: z.number().int(),
});
export const pongPayloadSchema = z.object({
    /** Echoed back unchanged so the client can compute round-trip time. */
    sentAt: z.number().int(),
    /** Server clock reading when the pong was emitted, in epoch milliseconds. */
    serverTime: z.number().int(),
});
/**
 * The server ended this session, and is about to close the socket.
 *
 * Sessions live on the server, so ending one is immediate: the next request
 * with its access token is refused, and this event turns that into a sign-out
 * on screen with the reason, rather than a shell whose requests start failing.
 *
 *   account_deleted   an administrator deleted the account
 *   account_disabled  an administrator (or the directory) disabled it
 *   session_revoked   this sign-in was ended: by the person elsewhere, or an administrator
 *   session_expired   it reached the maximum lifetime, or sat idle too long
 */
export const sessionRevokedReasonSchema = z.enum([
    'account_deleted',
    'account_disabled',
    'session_revoked',
    'session_expired',
]);
export const sessionRevokedSchema = z.object({
    reason: sessionRevokedReasonSchema,
});
//# sourceMappingURL=system.js.map